import { useLoaderData } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { apiGetMostMatchesWrestlerWomanListStats } from '../../../components/ui_components/ApiList';
import GeneralRenderingSpecificStats from '../../../components/MobileComponents/Stats/GeneralRenderingSpecificStats';


const MostFightsWrestlerFemaleMobile = () => {
    const wrestlersData = (useLoaderData() as any)?.['data'] ?? [];
    const [searchParams] = useSearchParams();
    const year = searchParams.get('year') || 'globale';

    return (
        <GeneralRenderingSpecificStats
            apiFunctionGetStats={apiGetMostMatchesWrestlerWomanListStats}
            title="Match"
            stat="fights_count"
            yearStart={year}
            wrestlerDataStart={wrestlersData}
        />
    );
};

export default MostFightsWrestlerFemaleMobile;